import bowser from 'yola-bowser';

const isRightClick = (event) => (bowser.macOS && event.ctrlKey) || event.button === 2;

export default isRightClick;
